import React from 'react';

function TimerIcon({ w, h, style, className, childrenClassNames: { path } }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 16 16"
      className={className}
      style={style}
    >
      <g fillRule="evenodd" fill="none">
        <path
          className={path}
          stroke="#000"
          d="M6 13.5A4.505 4.505 0 0 1 1.5 9c0-2.48 2.019-4.5 4.5-4.5a4.47 4.47 0 0 1 3.182 1.318A4.47 4.47 0 0 1 10.5 9c0 2.481-2.019 4.5-4.5 4.5zM6 3a6 6 0 1 0 0 12A6 6 0 0 0 6 3z"
        />
        <path
          className={path}
          stroke="#000"
          d="M7.024 8.858c0 .575-.452 1.04-1.012 1.04C5.454 9.898 5 9.433 5 8.858c0-.396.217-.74.533-.916l.316-2.795A.169.169 0 0 1 6.009 5c.081 0 .153.067.162.147l.314 2.794c.32.173.54.52.54.917M4.333 2h3.334C7.85 2 8 1.871 8 1.714V.286C8 .129 7.85 0 7.667 0H4.333C4.15 0 4 .129 4 .286v1.428c0 .157.15.286.333.286"
        />
      </g>
    </svg>
  );
}

TimerIcon.defaultProps = {
  w: 16,
  h: 16,
  style: {},
  childrenClassNames: {},
};

export default TimerIcon;
